import { useTranslation } from 'react-i18next'

import { HeroProps } from '../../components/molecules/Hero'
import type { Cheese } from '../../graphql/generated/api-graphql'
import { wediaImagesTransform } from '../Common/wedia'

const useCheeseHero = (data: Cheese): HeroProps => {
  const { t } = useTranslation()

  return {
    title: data?.title,
    text: data?.introduction ?? undefined,
    imageProps: {
      maxWidth: 1280,
      width: 1280,
      height: 512,
      withHD: true,
      withLazyLoading: false,
      alt: data?.title ?? data.pictureHeader?.alt ?? '',
      images: data.pictureHeader
        ? wediaImagesTransform(data.pictureHeader)
        : undefined,
    },
    mobileImageProps: {
      maxWidth: 370,
      width: 370,
      height: 200,
      withHD: true,
      withLazyLoading: false,
      images: data?.pictureHeader
        ? wediaImagesTransform(data.pictureHeader)
        : undefined,
      alt: data?.title ?? data.pictureHeader?.alt ?? '',
    },
    brandLogoProps:
      data.type === 'AOP'
        ? {
            maxWidth: 75,
            withHD: true,
            withLazyLoading: false,
            alt: t('protected_designation_of_origin'),
            images: [
              {
                src: '/static/assets/images/common/logo-aop-min.png',
                size: 75,
              },
              {
                src: '/static/assets/images/common/logo-aop-min.webp',
                size: 75,
              },
            ],
          }
        : data.type === 'IGP'
        ? {
            maxWidth: 75,
            withHD: true,
            withLazyLoading: false,
            alt: t('protected_geographical_indication'),
            images: [
              {
                src: '/static/assets/images/common/logo-igp-min.png',
                size: 75,
              },
              {
                src: '/static/assets/images/common/logo-igp-min.webp',
                size: 75,
              },
            ],
          }
        : data.brand?.pictureLogo
        ? {
            maxWidth: 200,
            width: 80,
            height: 80,
            withHD: true,
            withLazyLoading: false,
            alt: data.brand?.pictureLogo.alt ?? '',
            images: data.brand.pictureLogo
              ? wediaImagesTransform(data.brand.pictureLogo)
              : undefined,
          }
        : undefined,
  }
}

export default useCheeseHero
